import React from "react";
import { GameMessage } from '@/types';
import { useAppStore } from "@/hooks/useAppStore";

interface CrocodileProps {
  message: GameMessage;
}

export const Crocodile: React.FC<CrocodileProps> = ({
  message,
}) => {
  const sendGameEvent = useAppStore((state) => state.sendGameEvent);
  const { gameId, session, data } = message;
  const teeth: boolean[] = data.teeth || [];
  const { gameOver, badTeeth } = data;

  return (
    <div>
    {gameOver && <div className="m-auto text-center bg-red-500 rounded-lg">GAME OVER</div>}
    {!gameOver && <div className="m-auto rounded-lg w-40 h-40 bg-contain bg-no-repeat bg-[url(https://s3.amazonaws.com/mindgames.ca/wp-content/uploads/2021/09/65046-1.jpg)]"/>}
    {teeth.map((tooth: boolean, index: number) => {
      const canPick: boolean = !gameOver && tooth;
      return (
        <div
          className={`text-lg inline m-1 ${canPick ? 'cursor-pointer' : ''}`}
          onClick={() => canPick && sendGameEvent(gameId, session, { tooth: index })}
        >
          {gameOver && (badTeeth === index) ? '💥' : tooth ? '🦷' : '🕸️'}
        </div>)
      })}
    </div>
  );
};
